<script lang="ts" setup>
  interface Props {
    title: string
    description?: string
  }

  const { title, description } = defineProps<Props>()
</script>
<template>
  <div>
    <h1 class="font-semibold text-3xl leading-none text-shade-primary mb-4">{{ title }}</h1>
    <p class="text-shade-tertiary leading-none" v-if="description">{{ description }}</p>
  </div>
</template>
